import React from "react";
import PropTypes from "prop-types";
import { Paper, Box, ButtonBase, Typography } from "@mui/material";
import { motion } from "framer-motion";

import HomeIcon from "@mui/icons-material/Home";
import ChatIcon from "@mui/icons-material/Chat";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ArticleIcon from "@mui/icons-material/Article";
import SettingsIcon from "@mui/icons-material/Settings";

export default class Material3BottomNav extends React.Component {
    static propTypes = {
        value: PropTypes.number,
        onBottomChange: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {
            value: props.value ?? 0,
        };
    }

    componentDidUpdate(prevProps) {
        if (typeof this.props.value === "number" && this.props.value !== prevProps.value) {
            this.setState({ value: this.props.value });
        }
    }

    handleChange = (newValue) => {
        const { onBottomChange } = this.props;
        this.setState({ value: newValue });
        if (onBottomChange) onBottomChange(newValue, this);
    };

    checkTheme = () => {
        if (localStorage.getItem("theme") !== null) {
            return localStorage.getItem("theme").includes("true");
        } else {
            return true
        }
    }

    render() {
        const { value } = this.state;
        const iosInset = window?.main?.ios?.() ? 14 : 0;

        const items = [
            { key: 0, label: "الرئيسية", icon: <HomeIcon /> },
            { key: 1, label: "المجتمع", icon: <ChatIcon /> },
            { key: 2, label: "المفضلة", icon: <FavoriteBorderIcon /> },
            { key: 3, label: "الأخبار", icon: <ArticleIcon /> },
            { key: 4, label: "الإعدادات", icon: <SettingsIcon /> },
        ];

        return (
            <Paper
                elevation={0}
                sx={{
                    position: "fixed",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    borderTopLeftRadius: 16,
                    borderTopRightRadius: 16,
                    bgcolor: (theme) => theme.palette.background.paper,
                    borderTop: "1px solid #9e9e9e26",
                    pb: `${iosInset}px`,
                    zIndex: 1200,
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-around",
                        alignItems: "center",
                        height: 72,
                    }}
                >
                    {items.map((item) => {
                        const selected = value === item.key;
                        return (
                            <ButtonBase
                                disableRipple
                                key={item.key}
                                onClick={() => this.handleChange(item.key)}
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: 64,
                                    height: 64,
                                    color: selected ? "primary.main" : "text.secondary",
                                }}
                            >
                                {/* Icon wrapped with animated pill */}
                                <motion.div
                                    animate={{
                                        backgroundColor: selected
                                            ? window.matchMedia("(prefers-color-scheme: dark)").matches
                                                ? this.checkTheme() ? "rgb(38,46,57)" : "rgb(255,255,255)"
                                                : "rgba(0,0,0,0.08)"
                                            : "rgba(0,0,0,0)",
                                        scale: selected ? 1.1 : 1,
                                    }}
                                    transition={{ type: "spring", stiffness: 400, damping: 20 }}
                                    style={{
                                        borderRadius: 16, // egg/pill shape
                                        width: 56,
                                        height: 32,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        padding: "0 12px",
                                    }}
                                >
                                    {item.icon}
                                </motion.div>

                                <Typography
                                    variant="caption"
                                    sx={{
                                        mt: 0.5,
                                        fontSize: 12,
                                        fontWeight: 500,
                                        fontFamily: "Changa",
                                        color: selected ? "primary.main" : "text.secondary",
                                    }}
                                >
                                    {item.label}
                                </Typography>
                            </ButtonBase>
                        );
                    })}
                </Box>
            </Paper>
        );
    }
}
